import classnames from 'classnames';
import { serviceFeeWaiverTypeIds } from 'services/Preferences';
import React from 'react';
export const SUBSCRIPTION_TRP_PERSONAL_INVESTING = 'T. Rowe Price Personal Investing';
export const SUBSCRIPTION_TRP_COLLEGE_SAVINGS_PLAN = 'T. Rowe Price College Savings Plan';
export const SUBSCRIPTION_MD_COLLEGE_INVESTMENT_PLAN = 'Maryland College Investment Plan';
export const SUBSCRIPTION_AK529 = 'Alaska 529';

export const getAccountHeaderClassname = (accounts) => {
  const isRetirement = accounts[0].retirementAccount === true;

  return classnames({
    retirement: isRetirement,
    'non-retirement': !isRetirement
  });
};

export const getSubscribed = (accounts) => {
  const {hasOwnedCollegeSavingsOnly, isOwnedMaryland529, isOwnedAlaska529, isOwnedNational529} = accounts
    const additionalSubscriptions = []

    !hasOwnedCollegeSavingsOnly && additionalSubscriptions.push({title: SUBSCRIPTION_TRP_PERSONAL_INVESTING});
    isOwnedNational529 && additionalSubscriptions.push({title: SUBSCRIPTION_TRP_COLLEGE_SAVINGS_PLAN});
    isOwnedMaryland529 && additionalSubscriptions.push({title: SUBSCRIPTION_MD_COLLEGE_INVESTMENT_PLAN});
    isOwnedAlaska529 && additionalSubscriptions.push({title: SUBSCRIPTION_AK529});
    return additionalSubscriptions;
  }

  export const getCheckboxName = (categoryName) => categoryName.split('- ')[1];

  export const getSubscriptionKey = (subName) => {
    if(subName === SUBSCRIPTION_TRP_PERSONAL_INVESTING) {
      return `II`;
    }
    if(subName === SUBSCRIPTION_MD_COLLEGE_INVESTMENT_PLAN) {
      return `MD529`;
    }
    if(subName === SUBSCRIPTION_AK529) {
      return `AK529`;
    }
    if(subName === SUBSCRIPTION_TRP_COLLEGE_SAVINGS_PLAN) {
      return `NA529`;
    }
  }
  
  export const optOutAll = (optOutElections) =>
    optOutElections?.some(
      (election) =>
        election.categoryName.includes('Products & Services') && election.optOut
    ) &&
    optOutElections?.some(
      (election) =>
        election.categoryName.includes('Research & Surveys') && election.optOut
    ) &&
    optOutElections?.some(
      (election) =>
        election.categoryName.includes('Education & Insights') &&
        election.optOut
    );

  export const subOptOutElections = (formattedOptOutElections, subName) =>
    formattedOptOutElections?.find((el) => el.key === subName)
      ?.optOutElections || [];

export const hasAllInvestingRows = (eligibleMFServiceTypeIds) => serviceFeeWaiverTypeIds.every(
  (id) => eligibleMFServiceTypeIds && eligibleMFServiceTypeIds.includes(id)
);

export const Owners = ({ owners }) => (
  <span className="owners blocked_data">{owners}</span>
);

export const AccountNumber = ({ accountNumber, accountChecksum }) => (
  <span className="header-account-number">
    {accountNumber}-{accountChecksum}
  </span>
);
